<div>
  <button mat-button color="primary" class="custom-button" (click)="navigate()">
    {{ buttonLabel }}
  </button>
</div>
